import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_URL = `${BACKEND_URL}/api/customerprofile/`;

const getCustomerProfileFromContact = async (formData) => {
    return await axios.post(API_URL + 'bycontact', formData);
};

const getProfileFromPhone = async (formData) => {
    return await axios.post(API_URL + 'byphone', formData);
};

const getDefaultProfile = async (shop) => {
    return await axios.post(API_URL + 'default', {shop});
};

const getCustomerProfiles = async (shop) => {
    return await axios.post(API_URL, {shop});
};

const updateDefaultProfile = async (profile) => {
    return await axios.put(API_URL + 'default', profile)
}

const getDefaultRateAdjustments = async (shop) => {
    return await axios.post(API_URL + 'default-rate-adjustment', { shop });
};

const updateDefaultRateAdjustments = async (shop, rateAdjustments) => {
    return await axios.put(API_URL + 'default-rate-adjustment', { shop, rateAdjustments });
};

export default {
    getCustomerProfileFromContact,
    getDefaultProfile,
    updateDefaultProfile,
    getCustomerProfiles,
    getProfileFromPhone,
    getDefaultRateAdjustments,
    updateDefaultRateAdjustments
};
